import { Experiment, LANG } from '@naturalcycles/shared'

export const experimentConfigMap: Partial<Record<Experiment, ExperimentConfig>> = {
  [Experiment.QUIZ_PROGRESS_BAR]: {
    allowedLanguages: [LANG.en_US],
  },
  [Experiment.PROCEED_WITH_RECOMMENDED_DEVICE]: {
    allowedLanguages: [LANG.en_US, LANG.en_CA, LANG.en_GB],
  },
  [Experiment.QUIZ_REVAMP_USPS]: {
    allowedLanguages: [LANG.en_US],
  },
}

interface ExperimentConfig {
  /**
   * If undefined, any language is allowed.
   */
  allowedLanguages?: LANG[]
}
